import { API_ROUTE_ADMIN_TEXT_TEMPLATES } from '@/resources/api-routes'
import { update } from '@/util/auth'

import type { TextTemplateTypeOriginal } from './types'

const IS_NEW_BACKEND_API = true

export const updateTextTemplate = (
  postTextTemplatePayload: Partial<TextTemplateTypeOriginal>,
  id: number
) =>
  update<TextTemplateTypeOriginal>(
    `${API_ROUTE_ADMIN_TEXT_TEMPLATES}/${id}`,
    postTextTemplatePayload,
    IS_NEW_BACKEND_API
  )
